import { Component, ContentChild, OnInit } from '@angular/core';
import { MyLeadList, MyLeadListSidebar } from './my-lead-list-layout.directive';

@Component({
  selector: 'my-lead-list-layout',
  templateUrl: './my-lead-list-layout.component.html',
  styleUrls: ['./my-lead-list-layout.component.scss']
})
export class MyLeadListLayoutComponent implements OnInit {
  @ContentChild(MyLeadList) list: MyLeadList;
  @ContentChild(MyLeadListSidebar) sidebar: MyLeadListSidebar;

  public showSidebar?: boolean;

  constructor() {}

  ngOnInit() {}
}
